import React, { useState, useEffect } from 'react';
import YouTube from 'react-youtube';

import useAuth from '~/hooks/useAuth';

import bridge from '~/utils/pro-bridge';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import top from './images/top.png';
import mid from './images/mid.png';
import bottom from './images/bottom.png';

import agreeImg from './images/agree.png';

import manOff from './images/man-off.png';
import manOn from './images/man-on.png';
import womanOff from './images/woman-off.png';
import womanOn from './images/woman-on.png';

import off_20 from './images/20-off.png';
import on_20 from './images/20-on.png';
import off_30 from './images/30-off.png';
import on_30 from './images/30-on.png';
import off_40 from './images/40-off.png';
import on_40 from './images/40-on.png';
import off_50 from './images/50-off.png';
import on_50 from './images/50-on.png';

import showOff from './images/show-off.png';
import showOn from './images/show-on.png';
import noShowOff from './images/no-show-off.png';
import noShowOn from './images/no-show-on.png';

import submitBtn from './images/submit.png';

import { TopWrap, AgreeWrap, LabelWrap, Label, Checkbox, QuestionWrap } from './styled';

function MainComponent() {
  const [agree, setAgree] = useState(false);
  const [q1, setQ1] = useState('');
  const [q2, setQ2] = useState('');
  const [q3, setQ3] = useState('');
  const [content, setContent] = useState('');
  const [isSending, setSending] = useState(false);

  const { authKey } = useAuth();

  useEffect(() => {
    checkActive();
  }, []);

  function changeContent(e) {
    const { value } = e.currentTarget;

    if (/\s\s+/.test(value)) return;

    setContent(value);
  }

  async function checkActive() {
    try {
      const res = await apiCall.get(`${LIVE_URL}/api/v1/pro/event/2021/11/survey/active`);

      if (!res?.result) {
        alert('본 이벤트는 조기 마감되었습니다. 감사합니다.');
  
        bridge.android(call => {
          call.finishActivity();
        });
    
        bridge.ios(call => {
          call.callHandler('iOS Echo', {
            cmd: 'finishActivity',
          });
        });
      }
    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  async function submit() {
    if (!agree) return alert('본 이벤트는 개인정보 수집/이용및 제공항목에 동의 후 참여가능합니다.');
    if (q1 === '' || q2 === '' || q3 === '') return alert('1~3번 문항은 반드시 답변해주세요.');
    if (content === '' || content.length < 30) return alert('4번 문항은 최소 30자 이상 작성해주세요.');

    if (isSending) return;

    setSending(true);

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/pro/event/2021/11/survey`, {
        authKey,
        q1,
        q2,
        q3: q3 === 'show',
        q4: content,
      });

      const errorCode = [501, 502, 503, 504, 505, 506, 507];

      if (errorCode.includes(res.code)) {
        alert(res.msg);
        setSending(false);

        // 로그인 안되어 있는 경우 로그인 페이지로 이동
        if (res.code === 501) {
          bridge.android(call => {
            console.log('android');
            call.showLoginAndReload();
          });

          bridge.ios(call => {
            call.callHandler('iOS Echo', {
              cmd: 'showLoginAndReload',
            });
          });
        }
      } else if (res.code === 200) {
        alert('회원님의 소중한 의견 감사합니다.');

        bridge.android(call => {
          call.finishActivity();
        });
    
        bridge.ios(call => {
          call.callHandler('iOS Echo', {
            cmd: 'finishActivity',
          });
        });
      }

    } catch(err) {
      setSending(false);
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <div>
      <TopWrap>
        <BG width={1420} height={2562} imgUrl={top} />
      </TopWrap>
      <AgreeWrap>
        <LabelWrap>
          <Label isCheck={agree}>
            <Checkbox type="checkbox" checked={agree} onChange={() => setAgree(prev => !prev)} />
            <p>개인정보 수집/이용 에 대한 동의</p>
          </Label>
        </LabelWrap>
        
        <BG width={1300} height={404} imgUrl={agreeImg} />
        
        <div className="youtube">
          <YouTube videoId="y3ZMbnTdaUA" />
          <p>다방CF 15” <b>|</b> <span>중개사와의 약속, 다방은 지켜나가겠습니다</span> 편</p>
        </div>

        <div className="youtube">
          <YouTube videoId="LhdFBd-myhc" />
          <p>다방CF 15” <b>|</b> <span>다방은 개업공인중개사들과 끝까지 함께 하겠습니다</span> 편</p>
        </div>
      </AgreeWrap>
      <QuestionWrap>
        <BG BG width={1420} height={1910} imgUrl={mid} />
        <img className="q1-1" src={q1 === 'MAN' ? manOn : manOff} alt="" onClick={() => setQ1('MAN')} />
        <img className="q1-2" src={q1 === 'WOMAN' ? womanOn : womanOff} alt="" onClick={() => setQ1('WOMAN')} />
        
        <img className="q2-1" src={q2 === 'TWENTY' ? on_20 : off_20} alt="" onClick={() => setQ2('TWENTY')} />
        <img className="q2-2" src={q2 === 'THIRTY' ? on_30 : off_30} alt="" onClick={() => setQ2('THIRTY')} />
        <img className="q2-3" src={q2 === 'FORTY' ? on_40 : off_40} alt="" onClick={() => setQ2('FORTY')} />
        <img className="q2-4" src={q2 === 'FIFTY_OVER' ? on_50 : off_50} alt="" onClick={() => setQ2('FIFTY_OVER')} />

        <img className="q3-1" src={q3 === 'show' ? showOn : showOff} alt="" onClick={() => setQ3('show')} />
        <img className="q3-2" src={q3 === 'noShow' ? noShowOn : noShowOff} alt="" onClick={() => setQ3('noShow')} />

        <div className="text-wrap">
          <textarea value={content} onChange={changeContent} placeholder="최소 30자 이상을 입력해주세요." />
          <p>{content.length} / 30자</p>
        </div>

        <img className="submit" src={submitBtn} alt="" onClick={submit} />
      </QuestionWrap>
      <BG width={1420} height={1182} imgUrl={bottom} />
    </div>
  );
}

export default MainComponent;
